// extracted by mini-css-extract-plugin
export default {"wrapper":"StartPage_wrapper__K9LG6","title":"StartPage_title__ZFOoy","text":"StartPage_text__w7vKj"};